import React, { useRef, useState } from 'react';

// 3D holographic tilt card — tracks the cursor and projects a holo sheen.
export const HoloCard = ({ children, className = '', intensity = 9, ...props }) => {
  const ref = useRef(null);
  const [style, setStyle] = useState({ '--ho': 0 });

  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width;
    const py = (e.clientY - r.top) / r.height;
    setStyle({
      transform: `perspective(900px) rotateY(${(px - 0.5) * intensity}deg) rotateX(${(0.5 - py) * intensity}deg)`,
      '--mx': `${px * 100}%`,
      '--my': `${py * 100}%`,
      '--ho': 1,
    });
  };
  const reset = () => setStyle({ transform: 'perspective(900px) rotateY(0deg) rotateX(0deg)', '--ho': 0 });

  return (
    <div
      ref={ref}
      onMouseMove={onMove}
      onMouseLeave={reset}
      style={{ transformStyle: 'preserve-3d', transition: 'transform .18s ease', willChange: 'transform', ...style }}
      className={`holo ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};
